import { LoiFormsProcessStep, LoiFormsProcessStepStatus } from '../loi-comparison/models/loi-forms-process.model';

export interface InitialQuestionsAccessInput {
    isAdmin: boolean;
    isBuyer: boolean;
    isHistoricalVersion: boolean;
    isReadonly: boolean;
    isReadonlyDueToPermissions: boolean;
    isBuyerInactive: boolean;
    isPostedToSeller: boolean;
    isBuyerReviewConfirmed: boolean;
    processStep: LoiFormsProcessStep | undefined;
    processStepStatus: LoiFormsProcessStepStatus | undefined;
}

export interface InitialQuestionsAccess {
    isReadonly: boolean;
    canApprovePendingChanges: boolean;
}

export function resolveInitialQuestionsAccess(input: InitialQuestionsAccessInput): InitialQuestionsAccess {
    if (input.isHistoricalVersion) {
        return { isReadonly: true, canApprovePendingChanges: false };
    }

    if (input.isAdmin) {
        const isReadonly = input.isReadonly
            || input.processStep === undefined
            || input.processStep === LoiFormsProcessStep.BuyerSubmission;
        return { isReadonly, canApprovePendingChanges: false };
    }

    if (input.isBuyer) {
        const canEditAtSubmission = input.processStep === LoiFormsProcessStep.BuyerSubmission
            && !input.isReadonly
            && !input.isReadonlyDueToPermissions
            && !input.isBuyerInactive;
        const canEditAtReview = input.processStep === LoiFormsProcessStep.BuyerReview
            && input.processStepStatus === LoiFormsProcessStepStatus.InProgress
            && !input.isBuyerReviewConfirmed
            && !input.isReadonlyDueToPermissions
            && !input.isBuyerInactive;
        const isReadonly = !(canEditAtSubmission || canEditAtReview);
        const canApprovePendingChanges = (
            input.processStep === LoiFormsProcessStep.AdminReview
            || input.processStep === LoiFormsProcessStep.BuyerReview
        )
            && !input.isPostedToSeller
            && !input.isReadonlyDueToPermissions
            && !input.isBuyerInactive;
        return { isReadonly, canApprovePendingChanges };
    }

    return { isReadonly: true, canApprovePendingChanges: false };
}
